import React,{useEffect, useState} from 'react'
import { useParams, useHistory } from 'react-router-dom';
import Combo from './Home/Combo';
import axios from 'axios';

const PackDetails = ({theme}) => {
    const [data, setData] = useState([]);
    const [PlayerType, setPlayerType] = useState(undefined);
    const { id, type } = useParams();
    console.log(data);
    const history = useHistory();
    const colorString = Object.values({theme}).toString();

    useEffect(() => {
        window.scrollTo(0, 0);
        if(type === 'Player'){
            axios.get('https://appi.colexion.io/api/Player').then(resp => {
                const player = resp.data.find((player) => player._id === id);
                if(player === undefined){
                    axios.get('https://appi.colexion.io/api/Bowler').then(resp => {
                        setData(resp.data.find((player) => player._id === id));
                        setPlayerType('Bowler');
                    })
                } else {
                    setData(player);
                    setPlayerType('Batter');
                }
            });
        } else {
            axios.get('https://appi.colexion.io/api/Enter').then(resp => {
                setData(resp.data.find((Enter) => Enter._id === id));
            });
            //console.log(data)
        }
      }, [id, type])
    return (
        <React.Fragment>
            <section className={colorString === 'true'?`customSec pt-4 dark`: `customSec pt-4 whiteTheme`}>
                <div className="container">
                    <div className="productDetailsWrp">
                        <div className="productDetailsCard">
                            <div className="d-block">
                                <button className="normalLink" onClick={() => history.goBack()}><i className="fas fa-arrow-left"></i> Back</button>
                            </div>
                            <div className="productDetailsCardImg">
                                {type === 'Player' && <div className="countryFlag">
                                    <img src={"https://appi.colexion.io/"+data.cflag} alt="" />
                                </div>}
                                <div className="playerImg">
                                    <img src={"https://appi.colexion.io/"+(type === 'Player' ? data.pflag : data.img)} alt="" />
                                </div>
                                <div className="playerName">
                                    <span>{data.name}</span>
                                    <span><i>AGE</i> ({data.age})</span>
                                </div>
                            </div>
                            {
                                type === 'Player' ? (
                                    PlayerType === 'Batter' ? (<div className="playerStats">
                                    <h5>Stats</h5>
                                    <ul className="list-inline playerStatsList">
                                        <li>ONE DAY</li>
                                        <li><span>{data.orun || '-'}</span>Run</li>
                                        <li><span>{data.orate || '-'}</span>Avg</li>
                                        <li><span>{data.owicket || '-'}</span>HS</li>
                                        <li><span>{data.ocatch || '-'}</span>Matches</li>
                                    </ul>
                                    <ul className="list-inline playerStatsList">
                                        <li>Test Match</li>
                                        <li><span>{data.trun || '-'}</span>Run</li>
                                        <li><span>{data.trate || '-'}</span>Avg</li>
                                        <li><span>{data.twicket || '-'}</span>HS</li>
                                        <li><span>{data.tcatch || '-'}</span>Matches</li>
                                    </ul>
                                    <ul className="list-inline playerStatsList">
                                        <li>T20</li>
                                        <li><span>{data.t2run || '-'}</span>Run</li>
                                        <li><span>{data.t2rate || '-'}</span>Avg</li>
                                        <li><span>{data.t2wicket || '-'}</span>HS</li>
                                        <li><span>{data.t2catch || '-'}</span>Matches</li>
                                    </ul>
                                </div>) : ( //Bowler starts
                                    <div className="playerStats">
                                    <h5>Stats</h5>
                                    <ul className="list-inline playerStatsList">
                                        <li>ONE DAY</li>
                                        <li><span>{data.oavg || '-'}</span>Economy</li>
                                        <li><span>{data.obest || '-'}</span>BBI</li>
                                        <li><span>{data.owicket || '-'}</span>Wickets</li>
                                        <li><span>{data.ocatch || '-'}</span>Matches</li>
                                    </ul>
                                    <ul className="list-inline playerStatsList">
                                        <li>Test Match</li>
                                        <li><span>{data.tavg || '-'}</span>Economy</li>
                                        <li><span>{data.tbest || '-'}</span>BBI</li>
                                        <li><span>{data.twicket || '-'}</span>Wickets</li>
                                        <li><span>{data.tcatch || '-'}</span>Matches</li>
                                    </ul>
                                    <ul className="list-inline playerStatsList">
                                        <li>T20</li>
                                        <li><span>{data.t2avg || '-'}</span>Economy</li>
                                        <li><span>{data.t2best || '-'}</span>BBI</li>
                                        <li><span>{data.t2wicket || '-'}</span>Wickets</li>
                                        <li><span>{data.t2catch || '-'}</span>Matches</li>
                                    </ul>
                                </div>
                                )
                                ) : undefined
                            }
                        </div>
                        <div className="productDetailsContent">
                            <h2>{data.name}</h2>
                            <p  dangerouslySetInnerHTML={{ __html: (type === 'Enter' ? data.details : data.des)} }></p>
                            {/* <h4>To understand the cards, here are a few tips:</h4>
                            <ul>
                                <li>Every combo will come with a set of 5.</li>
                                <li>Gold and silver cards will make up the Star combo.</li>
                                <li>Only silver cards will make up the Super combo.</li>
                                <li>Multiple combos will be available on Colexion.</li>
                                <li>The price will vary according to the available cards in each combo.</li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </section>
            
        <Combo theme={{theme}}/>
        <section className={colorString === 'true'?`customSec speciality pb-2 dark`: `customSec speciality pb-2 whiteTheme`}>
            <div className="container">
                <div className="sectionHeading">
                    <div className="d-block">
                        <h2>colexion speciality</h2>
                        <h3>What’s the Big Deal?  </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4 col-12">
                        <div className="bx">
                            <img src={process.env.PUBLIC_URL + '/images/ico1.png'} alt="" />
                            <h3>Introductry pack</h3>
                            <p>Journey towards Success</p>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="bx">
                            <img src={process.env.PUBLIC_URL + '/images/ico2.png'} alt="" />
                            <h3>Autograph Cards</h3>
                            <p>Celebrities Hallmark</p>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="bx">
                            <img src={process.env.PUBLIC_URL + '/images/ico3.png'} alt="" />
                            <h3>Triumph Deck</h3>
                            <p>Victory Moments </p>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="bx">
                            <img src={process.env.PUBLIC_URL + '/images/ico4.png'} alt="" />
                            <h3>videos</h3>
                            <p>Momentous NFT</p>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="bx">
                            <img src={process.env.PUBLIC_URL + '/images/ico2.png'} alt="" />
                            <h3>Stamp Card</h3>
                            <p>Celebrities Impression</p>
                        </div>
                    </div>
                    <div className="col-sm-4 col-12">
                        <div className="bx">
                            <img src={process.env.PUBLIC_URL + '/images/ico5.png'} alt="" />
                            <h3>Classic Deck</h3>
                            <p>SVintage NFT</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </React.Fragment>
    )
}
export default PackDetails;